import React, {Component} from "react";
import {Modal} from "antd";
import Styles from "./packingPreview.module.css";
import printJS from "print-js";
import BarCode from "../report-order/components/barcode";


class PackingPreview extends Component {

    state = {}

    onOk = () => {
        printJS({
            printable: 'report_table_packing_preview',
            type: 'html',
            maxWidth: 'auto',
            documentTitle: '厦门',
            targetStyle: ['fill', 'transform', 'text-align', 'height', 'padding-left', 'float', 'line-height', 'vertical-align'],
            style: 'table{width:100%}; word-break:break-all;}'
        })
    }

    render() {
        const {records, order, ...otherProps} = this.props;
        return (
            <Modal onOk={this.onOk} {...otherProps}>
                <table id={'report_table_packing_preview'} className={Styles.tablePreview} border="1" cellSpacing='0'>
                    <thead>
                    <tr>
                        <td colSpan={7}>
                            <div className={Styles.tableHeader}>
                                <div><BarCode height={50} width={1.3} fontSize={10} value={order.packing_no} /></div>
                                <h3 style={{textAlign: 'center'}}>装运单</h3>
                            </div>
                        </td>
                        <td colSpan={2} style={{textAlign: 'left'}}>计划发货日期：</td>
                    </tr>
                    <tr>
                        <td>序号</td>
                        <td>产品ID</td>
                        <td>采购单号/行号</td>
                        <td>物料编号</td>
                        <td>自由库位</td>
                        <td>订单交期</td>
                        <td>订单数量</td>
                        <td>装运数量</td>
                        <td>剩余数量</td>
                    </tr>
                    </thead>
                    <tbody>
                    {records.map((record, index) => (
                        <tr>
                            <td>{index + 1}</td>
                            <td>{record.product_no}</td>
                            <td>{record.purchase_no}/{record.line_no}</td>
                            <td>{record.product_id}</td>
                            <td>{record.temporary_location}</td>
                            <td>{record.delivery_date}</td>
                            <td>{record.qty}</td>
                            <td>{record.packing_qty}</td>
                            <td>{record.remain_qty}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </Modal>
        );
    }

}

export default PackingPreview;
